import { Avatar, Body } from '@e2n/ui/v2';
import { ArbeitnehmerTyp } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitnehmerTyp';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { ArbeitnehmerTypFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplan/components/ArbeitnehmerTypFilter';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SelectV2';
import { useMitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useMitarbeiter/useMitarbeiter';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function MitarbeiterSelect({
  id,
  invalid = false,
  onChange,
  value,
}: {
  id?: string;
  invalid?: boolean;
  onChange: (mitarbeiter: Mitarbeiter) => void;
  value?: Mitarbeiter;
}) {
  const { t } = useTranslation();
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const { mitarbeiter } = useMitarbeiter(standortIds);

  const [selectedArbeitnehmerTypes, setSelectedArbeitnehmerTypes] = useState<
    ArbeitnehmerTyp[]
  >(['AZUBI']);

  const filteredMitarbeiter = mitarbeiter.filter(
    (m) =>
      m.arbeitnehmerTyp !== undefined &&
      selectedArbeitnehmerTypes.includes(m.arbeitnehmerTyp),
  );

  return (
    <Select<Mitarbeiter>
      id={id}
      invalid={invalid}
      selectedOption={value}
      onChange={onChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.fields.mitarbeiter.label',
      )}
      options={filteredMitarbeiter}
      getOptionLabel={(m) => m.getName()}
      searchAddon={
        <ArbeitnehmerTypFilter
          value={selectedArbeitnehmerTypes}
          onValueChange={setSelectedArbeitnehmerTypes}
        />
      }
      renderListItem={(mitarbeiter, selectedMitarbeiter) => (
        <div className="flex w-full min-w-0 items-center gap-2">
          {mitarbeiter.imgUrl ? (
            <Avatar
              size="xs"
              src={mitarbeiter.imgUrl}
              alt={mitarbeiter.getName()}
              fallbackInitials={mitarbeiter.getInitials()}
            />
          ) : (
            <Avatar
              size="xs"
              type="initials"
              initials={mitarbeiter.getInitials()}
            />
          )}
          <Body className="min-w-0 flex-1 truncate">
            {mitarbeiter.getName()}
          </Body>
          {mitarbeiter.id === selectedMitarbeiter?.id && (
            <FontAwesomeIcon
              className="size-4 text-brand-red-200"
              icon={faCheck}
            />
          )}
        </div>
      )}
    />
  );
}
